export default {
  appSettings: 'Ustawienia aplikacji',
  userSettings: 'Ustawienia użytkownika',
  tenantSettings: 'Ustawienia Qmulus',
  APIKey: 'Klucze API',
  notificationChannel: 'Kanały powiadomień',
  userSubscription: 'Subskrypcje użytkowników',
  channels: 'Kanały',
  reportBuilder: 'Kreator raportów',
  assetParameterDefinition: 'Definicje parametrów aktywów',
};
